import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const footerTopStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: ${pxToRem(theme.spacing['500'])} ${pxToRem(theme.spacing['300'])}
		${pxToRem(theme.spacing['600'])} ${pxToRem(theme.spacing['300'])};
	background-color: ${theme.colors.base.bgFooterSecondary};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.xs)}) {
		padding-left: ${pxToRem(theme.spacing['400'])};
		padding-right: ${pxToRem(theme.spacing['400'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		padding-left: ${pxToRem(theme.spacing['500'])};
		padding-right: ${pxToRem(theme.spacing['500'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		padding: ${pxToRem(theme.spacing['700'])} ${pxToRem(theme.spacing['500'])}
			${pxToRem(theme.spacing['800'])} ${pxToRem(theme.spacing['500'])};
	}
`;
export const StyledFooterTop = styled.div `
	${footerTopStyles}
`;
const footerTopContentStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['500'])};
	width: 100%;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: ${pxToRem(theme.spacing['400'])};
		max-width: ${pxToRem(theme.containerWidth.containerWidthMax)};
	}
`;
export const StyledFooterTopContent = styled.div `
	${footerTopContentStyles}
`;
